import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitDemoRequest = (payload) =>
  axios.post(`${API}/demo-requests`, payload).then((r) => r.data);

export const submitCalculatorLead = (payload) =>
  axios.post(`${API}/calculator-leads`, payload).then((r) => r.data);
